import React from "react";
import { Link } from "gatsby";

import './styles.scss';

const LocalLink = ({ children, href, ...restProps }) => (
  <Link className="ams-link" to={href} {...restProps}>{children}</Link>
);

export default LocalLink;
